export default __webpack_public_path__ + "static/media/Ontwerpdocument.70113829.pdf";